import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { MULTI_CTA_MODAL_OPEN_BTN } from 'constants/CommonConstants';
import { useParams } from 'react-router-dom';
import useQueryParams from 'hooks/UseQueryParams';
import { authenticate } from 'store/Auth';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const MultiCTA: React.FC = () => {
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();
  const hasCalledMounted = React.useRef(false);
  const queryParams = useQueryParams();
  const { token } = useParams();
  const domain = queryParams.get('domain');
  const type = queryParams.get('type');

  const authenticateAndPostMessage = async () => {
    try {
      const authData = { token, domain }; // Create the payload

      dispatch(authenticate(authData)).then((res) => {
        const widgetData = res?.payload?.data?.widgetData;

        const bgColor = widgetData?.bgColor;
        const customClassName = widgetData?.customClassName;
        const buttonName = widgetData?.buttonName;
        const success = res?.payload?.success;
        const language = widgetData?.language;
        const widgetName = res?.payload?.data?.widgetName;

        window.parent.postMessage(
          {
            type: MULTI_CTA_MODAL_OPEN_BTN,
            res: {
              bgColor,
              customClassName,
              success,
              buttonName,
              language,
              widgetName,
              type,
              module: 'multi-cta',
              widgetData,
            },
          },
          '*'
        );
      });
    } catch (error) {
      console.error('Error fetching search results:', error);
    }
  };

  useEffect(() => {
    if (hasCalledMounted.current) return;
    hasCalledMounted.current = true;

    authenticateAndPostMessage();
  }, []);

  return null;
};

export default MultiCTA;
